var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMagnifierIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2xLupa") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lupa",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F1F5F8",
    cx: 24,
    cy: 24,
    r: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.35775,21.67845 C29.35775,25.3666 26.3666,28.3569 22.6793,28.3569 C18.9903,28.3569 16,25.3666 16,21.67845 C16,17.9903 18.9903,15 22.6793,15 C26.3666,15 29.35775,17.9903 29.35775,21.67845 Z",
    id: "Stroke-1",
    stroke: "#7B96AB",
    strokeWidth: 2.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 33.17442,
    y1: 32.55165,
    x2: 27.21422,
    y2: 26.59145,
    id: "Stroke-3",
    stroke: "#7B96AB",
    strokeWidth: 2.1,
    strokeLinecap: "square"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifierIcon);
export default __webpack_public_path__ + "static/media/magnifier_icon.fb53b680f3202338b05bdd1163f0bc01.svg";
export { ForwardRef as ReactComponent };